import { render } from "./StudioLayout.vue?vue&type=template&id=5fc066de&scoped=true"
import script from "./StudioLayout.vue?vue&type=script&lang=js"
export * from "./StudioLayout.vue?vue&type=script&lang=js"

import "./StudioLayout.vue?vue&type=style&index=0&id=5fc066de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc066de"]])

export default __exports__